export const elementsSelectors = [
    "ux-autosuggest-input",
    "ux-input-field",
    "ux-checkbox",
    "ux-date-picker",
    "ux-file-upload",
    "ux-phone-input",
    "ux-select",
    "ux-form-group",
    "ux-textarea-field",
    "ux-password-input"
];
//# sourceMappingURL=supported-elements-selectors.js.map
